import React from 'react';

const Loader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className='loading-layer-sized no-background padded-bottom-50'>
      <div className='spinner-loader-centered spinner-loader-big-no-margin'></div>
    </div>
  )
};

export default Loader;
